/**
 * Collection page enhancements:
 *  - Mobile filter drawer open/close + focus trap + Esc
 *  - Sort dropdown auto-submits on change
 *  - Focus management on drawer
 */
(function () {
  'use strict';

  function init() {
    const root = document.querySelector('[data-collection]');
    if (!root) return;

    const panel = root.querySelector('[data-filter-panel]');
    const openBtn = root.querySelector('[data-filter-open]');
    const closeBtn = root.querySelector('[data-filter-close]');
    const scrim = document.querySelector('[data-filter-scrim]');
    const sortForm = root.querySelector('[data-sort-form]');
    const sortSelect = root.querySelector('[data-sort-select]');

    let lastFocused = null;

    function openDrawer() {
      if (!panel) return;
      lastFocused = document.activeElement;
      panel.classList.add('is-open');
      if (scrim) {
        scrim.hidden = false;
        requestAnimationFrame(() => scrim.classList.add('is-visible'));
      }
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (scrim) {
        scrim.classList.remove('is-visible');
        setTimeout(() => { scrim.hidden = true; }, 250);
      }
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) closeDrawer();
    });

    // Auto-submit sort form on change (no "Apply" button needed)
    if (sortForm && sortSelect) {
      sortSelect.addEventListener('change', () => {
        sortForm.submit();
      });
    }

    // Close drawer automatically if viewport grows past the mobile breakpoint
    const mql = window.matchMedia('(max-width: 900px)');
    mql.addEventListener('change', (e) => {
      if (!e.matches && panel) closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
